{
  "nl": {
    "common": {
      "description": "Omschrijving",
      "email_address_status": {
        "spam_complaint_reactivation": "Spamklachten kunnen hier niet opnieuw worden geactiveerd. Dit kan alleen handmatig via {link}.",
        "spam_complaint_reactivation_link": "Postmark"
      },
      "search": "Zoeken",
      "selected": "Geselecteerd",
      "title": "Titel"
    }
  }
}
